export default {
  numeric: value => value.replace(/\D/g, ''),
  uppercase: value => (value && typeof (value) === 'string' ? value.toUpperCase() : value),
};
